import { render } from "./MessagingSection.vue?vue&type=template&id=a9b77ce4&scoped=true"
import script from "./MessagingSection.vue?vue&type=script&lang=js"
export * from "./MessagingSection.vue?vue&type=script&lang=js"

import "./MessagingSection.vue?vue&type=style&index=0&id=a9b77ce4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b77ce4"]])

export default __exports__